import React, { ReactNode } from "react";
import styles from "./flex-column-container.module.scss";

const cssClassName = "flex-column-container";

interface FlexColumnContainerProps {
  verticalGap?: number;
  alignItems?: "flex-start" | "center" | "flex-end" | "stretch";
  justifyContent?: "flex-start" | "center" | "flex-end";
  children: ReactNode;
}

export const FlexColumnContainer = ({
  verticalGap = 8,
  alignItems = "flex-start",
  justifyContent = "flex-start",
  children,
}: FlexColumnContainerProps) => {
  const styleVars = {
    "--align-items": alignItems,
    "--vertical-gap": `${verticalGap}px`,
    "--justify-content": justifyContent,
  } as React.CSSProperties;

  return (
    <div className={styles[cssClassName]} style={styleVars}>
      {children}
    </div>
  );
};
